/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ProveedorEstado from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import FormularioColumnasCV from './controladorVista/formularioColumnasCV';
import TablaColumnasCV from './controladorVista/tablaColumnasCV';
import { estadoIncial, reductor } from './reductorColumnas';

const Columnas: React.FunctionComponent = () => (
    <ProveedorEstado estadoInicial={estadoIncial} reductor={reductor}>
        <TablaColumnasCV />
        <FormularioColumnasCV />
    </ProveedorEstado>
);

export default Columnas;
